import gql from 'graphql-tag';

export default gql`
  query allwaysAllegiantLogos {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        images(section: "otherIcons") {
          id
          path
          alt
          title
        }
      }
    }
  }
`;
